import { Translation } from './types';
import { APP_CONFIG } from './config/app.config';

export const MIN_QUANTITY = APP_CONFIG.store.minQuantity;

export const TRANSLATIONS: Translation = {
  home: { en: 'Home', pl: 'Strona Główna' },
  categories: { en: 'Categories', pl: 'Kategorie' },
  cart: { en: 'Cart', pl: 'Koszyk' },
  admin: { en: 'Admin', pl: 'Admin' },
  addToCart: { en: 'Add to Cart', pl: 'Dodaj do koszyka' },
  checkout: { en: 'Checkout', pl: 'Kasa' },
  total: { en: 'Total', pl: 'Suma' },
  name: { en: 'Name', pl: 'Imię' },
  email: { en: 'Email', pl: 'Email' },
  address: { en: 'Address', pl: 'Adres' },
  city: { en: 'City', pl: 'Miasto' },
  zip: { en: 'Zip Code', pl: 'Kod pocztowy' },
  placeOrder: { en: 'Place Order', pl: 'Złóż zamówienie' },
  orderSuccess: { en: 'Order placed successfully!', pl: 'Zamówienie złożone pomyślnie!' },
  emptyCart: { en: 'Your cart is empty', pl: 'Twój koszyk jest pusty' },
  manageCategories: { en: 'Manage Categories', pl: 'Zarządzaj Kategoriami' },
  manageOrders: { en: 'Manage Orders', pl: 'Zarządzaj Zamówieniami' },
  manageProducts: { en: 'Manage Products', pl: 'Zarządzaj Produktami' },
  addProduct: { en: 'Add Product', pl: 'Dodaj Produkt' },
  price: { en: 'Price', pl: 'Cena' },
  quantity: { en: 'Qty', pl: 'Ilość' },
  remove: { en: 'Remove', pl: 'Usuń' },
  featured: { en: 'Featured Products', pl: 'Polecane Produkty' },
  shopByCategories: { en: 'Shop by Categories', pl: 'Kupuj według Kategorii' },
  browseCategory: { en: 'Browse', pl: 'Przeglądaj' },
  exploreCollection: { en: 'Explore our', pl: 'Odkryj naszą kolekcję' },
  askAi: { en: 'Ask AI about this product', pl: 'Zapytaj AI o ten produkt' },
  adminDashboard: { en: 'Admin Dashboard', pl: 'Panel Administratora' },
  products: { en: 'Products', pl: 'Produkty' },
  back: { en: 'Back', pl: 'Wróć' },
  loading: { en: 'Loading...', pl: 'Ładowanie...' },
  phone: { en: 'Phone Number', pl: 'Numer Telefonu' },
  taxNumber: { en: 'Tax Number', pl: 'NIP' },
  subtotal: { en: 'Subtotal (Net)', pl: 'Netto' },
  vat: { en: 'VAT (23%)', pl: 'VAT (23%)' },
  totalGross: { en: 'Total (Gross)', pl: 'Brutto' },
  edit: { en: 'Edit', pl: 'Edytuj' },
  save: { en: 'Save', pl: 'Zapisz' },
  cancel: { en: 'Cancel', pl: 'Anuluj' },
  delete: { en: 'Delete', pl: 'Usuń' },
  add: { en: 'Add', pl: 'Dodaj' },
  search: { en: 'Search...', pl: 'Szukaj...' },
  filter: { en: 'Filter', pl: 'Filtruj' },
  all: { en: 'All', pl: 'Wszystkie' },
  stock: { en: 'Stock', pl: 'Zapas' },
  discount: { en: 'Discount %', pl: 'Rabat %' },
  isFeatured: { en: 'Featured', pl: 'Wyróżnione' },
  status: { en: 'Status', pl: 'Status' },
  pending: { en: 'Pending', pl: 'Oczekujące' },
  processing: { en: 'Processing', pl: 'W trakcie' },
  shipped: { en: 'Shipped', pl: 'Wysłane' },
  delivered: { en: 'Delivered', pl: 'Dostarczone' },
  cancelled: { en: 'Cancelled', pl: 'Anulowane' },
  actions: { en: 'Actions', pl: 'Akcje' },
  customer: { en: 'Customer', pl: 'Klient' },
  orderDetails: { en: 'Order Details', pl: 'Szczegóły zamówienia' },
  trackingNumber: { en: 'Tracking Number', pl: 'Numer śledzenia' },
  notes: { en: 'Notes', pl: 'Notatki' },
  analytics: { en: 'Analytics', pl: 'Analityka' },
  totalSales: { en: 'Total Sales', pl: 'Całkowita sprzedaż' },
  totalOrders: { en: 'Total Orders', pl: 'Zamówienia' },
  avgOrderValue: { en: 'Avg Order Value', pl: 'Średnia wartość' },
  topProducts: { en: 'Top Products', pl: 'Top produkty' },
  addCategory: { en: 'Add Category', pl: 'Dodaj kategorię' },
  categoryName: { en: 'Category Name', pl: 'Nazwa kategorii' },
  english: { en: 'English', pl: 'Angielski' },
  polish: { en: 'Polish', pl: 'Polski' },
  confirmDelete: { en: 'Are you sure?', pl: 'Czy na pewno?' },
  inStock: { en: 'In Stock', pl: 'W magazynie' },
  outOfStock: { en: 'Out of Stock', pl: 'Brak w magazynie' },
  lowStock: { en: 'Low Stock', pl: 'Niski stan' },
  updateProduct: { en: 'Update Product', pl: 'Aktualizuj produkt' },
  productDetails: { en: 'Product Details', pl: 'Szczegóły produktu' },
  imageUrl: { en: 'Image URL', pl: 'URL obrazu' },
  logout: { en: 'Logout', pl: 'Wyloguj' },
  inCart: { en: 'In Cart', pl: 'W koszyku' },
  goToCheckout: { en: 'Go to Checkout', pl: 'Przejdź do kasy' },
  myOrders: { en: 'My Orders', pl: 'Moje Zamówienia' },
  noOrders: { en: 'No orders yet', pl: 'Brak zamówień' },
  orderDate: { en: 'Order Date', pl: 'Data zamówienia' },
  viewOrder: { en: 'View Order', pl: 'Zobacz zamówienie' },
  backToOrders: { en: 'Back to Orders', pl: 'Wróć do zamówień' },
  orderNumber: { en: 'Order #', pl: 'Zamówienie #' },
  continueShopping: { en: 'Continue Shopping', pl: 'Kontynuuj zakupy' },
  orderNotFound: { en: 'Order not found', pl: 'Zamówienie nie znalezione' },
};